export default __webpack_public_path__ + "static/media/dhl.bbb26a7a.svg";